import { render, staticRenderFns } from "./StudentInputForm.vue?vue&type=template&id=046698be"
import script from "./StudentInputForm.vue?vue&type=script&lang=ts"
export * from "./StudentInputForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports